<template>
  <thead>
    <tr>
      <th scope="col-1">
        <span class='search-result-header'>Select</span>
      </th>
      <th scope="col-3" class="contact-name-column">
        <span class='search-result-header'>Name</span>
      </th>
      <th scope="col-3" class="contact-name-column">
        <span class='search-result-header'>Address</span>
      </th>
      <th scope="col-3" class="contact-role-column">
        <span class='search-result-header'>Role(s)</span>
      </th>
      <th scope="col-2"></th>
    </tr>
  </thead>
</template>
<script>
export default {
  name: 'ContactSearchResultHeader',
};
</script>
